import React, { Component } from 'react';
import { translate } from 'react-i18next';

import { IntelliSortTeamSelector } from 'common/components/intellisort/IntelliSortTeamSelector';
import TimeUtils from 'common/utils/TimeUtils';
import IntelliSortDatePicker from 'common/components/intellisort/IntelliSortDatePicker';
import { headerWithLogoutAndBUFactory } from 'common/components/core/app_bar/HeaderWithLogoutAndBU';

const IntelliSortLeft = ({ theme, teams, onTeamChange, selectedTeamId }) => {
    return (
        <div className={theme.left}>
            <IntelliSortTeamSelector
                teams={teams}
                selectedTeamId={selectedTeamId}
                onTeamChange={onTeamChange}
            />
        </div>
    );
};
const DatePicker = ({ theme, selectedDate, onDateChange }) => {
    return (
        <IntelliSortDatePicker
            selectedDate={selectedDate}
            onDateChange={onDateChange}
            className={theme.DatePicker}
        />
    );
};
const IntelliSortHeader = headerWithLogoutAndBUFactory({
    Left: IntelliSortLeft,
    Right: DatePicker
});
class IntelliSortAppHeader extends Component {
    constructor(props) {
        super(props);
        this.checkAndClearUrlDate(this.props);
    }

    componentDidUpdate(nextProps) {
        this.checkAndClearUrlDate(nextProps);
    }

    checkAndClearUrlDate(props) {
        const { clearUrlDate, selectedDate } = props;
        if (selectedDate && !TimeUtils.isValidDate(selectedDate)) {
            clearUrlDate();
        }
    }

    render() {
        return <IntelliSortHeader {...this.props} />;
    }
}

export default translate('translations')(IntelliSortAppHeader);
